import React, {useState} from 'react';
import PropTypes from 'prop-types';

import './Login.css';

async function loginUser(credentials) {
    const res = await fetch(`${process.env.REACT_APP_API_URL}/user/login`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(credentials),
        credentials: "include",
    });

    if (!res.ok) {
        const message = await res.text();
        throw new Error(`Login failed: ${res.status} ${message}`);
    }

    return res.json();
}

export default function Login({setTokens}) {
    const [username, setUserName] = useState('');
    const [password, setPassword] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const data = await loginUser({username, password});
            console.log("Login response:", data);
            const {access_token, refresh_token} = data;
            setTokens({access_token, refresh_token});
            alert("Login successful!");
        } catch (e) {

            alert("Login failed");
        }
    };

    return (
        <div className="login-wrapper">
            <h1>Please Log In</h1>
            <form onSubmit={handleSubmit}>
                <label>
                    <p>Username</p>
                    <input type="text" onChange={e => setUserName(e.target.value)}/>
                </label>
                <label>
                    <p>Password</p>
                    <input type="password" onChange={e => setPassword(e.target.value)}/>
                </label>
                <div>
                    <button type="submit">Log In</button>
                </div>
            </form>
        </div>
    );
}

Login.propTypes = {
    setTokens: PropTypes.func.isRequired,
};